var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAhmedabad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.447,
    height: 62.459,
    viewBox: "0 0 62.447 62.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928",
    transform: "translate(-1259.493 -334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20501",
    "data-name": "Path 20501",
    d: "M3471.052,172.111V158.58c-.615,0-1.213,0-1.812,0-.739-.006-1.183-.3-1.266-.857-.1-.644.27-.984.818-1.239,4.711-2.19,9.412-4.4,14.131-6.574a.973.973,0,0,0,.659-1.067c-.026-3.556-.014-7.112-.013-10.667,0-1.144.313-1.452,1.473-1.452,3.556,0,7.112.006,10.668-.006.617,0,1.149.11,1.338.769s-.217,1.038-.745,1.348c-1.114.653-2.215,1.329-3.417,2.052l2.91,1.751c.223.134.444.27.668.4a1.031,1.031,0,0,1,.585,1.243,1.052,1.052,0,0,1-1.141.77c-1.887-.006-3.773,0-5.659,0h-4.6c0,1.464-.02,2.867.024,4.269.006.182.316.417.536.52q5.729,2.7,11.472,5.362,1.412.659,2.825,1.317a1.045,1.045,0,0,1,.725,1.228,1.061,1.061,0,0,1-1.217.837c-.6-.014-1.205,0-1.841,0v13.531c.561,0,1.137.027,1.711-.007a1.359,1.359,0,0,1,1.423.886c1.826,3.687,3.685,7.358,5.509,11.046a.868.868,0,0,0,.931.577c1.257-.036,2.515-.005,3.772-.015a1.105,1.105,0,0,1,1.218.927c1.012,4.1,2.037,8.192,3.044,12.291a1.034,1.034,0,0,1-1.06,1.354c-.13.007-.26,0-.39,0h-59.451a3.89,3.89,0,0,1-.649-.02c-.688-.117-.993-.692-.792-1.5q1.043-4.19,2.1-8.378c.289-1.155.572-2.311.86-3.467.25-1.007.5-1.2,1.524-1.206,1.192,0,2.385-.02,3.577.01a.825.825,0,0,0,.887-.543c1.8-3.65,3.646-7.278,5.44-10.931a1.527,1.527,0,0,1,1.663-1.035C3469.982,172.15,3470.483,172.111,3471.052,172.111Zm-6.593,12.457h40.291c-.243-.5-.493-.927-.666-1.386a.955.955,0,0,0-1.067-.677q-18.4.029-36.808.015a1.618,1.618,0,0,0-.453.01.692.692,0,0,0-.394.25C3465.054,183.343,3464.779,183.927,3464.459,184.568Zm38.22-4.16c-.267-.536-.543-1-.734-1.5-.179-.465-.466-.567-.937-.566q-11.478.023-22.956.011-4.942,0-9.885.006c-.222,0-.566.01-.646.142-.362.6-.649,1.237-.986,1.9Zm-34.052-4.17h31.963c-.257-.52-.521-.967-.7-1.446a.867.867,0,0,0-.975-.613q-9.916.029-19.833.013c-2.969,0-5.939,0-8.909.009-.21,0-.527.061-.612.2C3469.219,174.974,3468.95,175.586,3468.627,176.238Zm26.741-19.773c-.172-.108-.234-.156-.3-.189-3.373-1.575-6.744-3.154-10.127-4.707a1.048,1.048,0,0,0-.773.048c-3.282,1.513-6.555,3.047-9.829,4.578-.128.06-.252.129-.523.269Zm-30.5,34.336h8.245v-4.085h-8.245Zm10.425-4.09v4.084h8.244v-4.084Zm18.66.018H3485.7v4.082h8.245Zm2.14,4.072h8.245v-4.085h-8.245Zm-36.43,6.244h8.245v-4.084h-8.245Zm18.651.032v-4.107h-8.222v4.107Zm10.408,0v-4.107H3480.5v4.107Zm10.408,0v-4.107H3490.9v4.107Zm10.409,0v-4.107h-8.222v4.107Zm-36.329-38.469v13.448h2V158.609Zm4.164,0v13.448h2V158.609Zm4.162,0v13.448h2V158.611Zm4.165,0v13.448h2V158.609Zm4.162,0v13.448h2V158.61Zm4.163,0V172.06h2.006V158.611Zm-2-15.663.059-.11-1.47-.893c-1.071-.65-1.074-1.467-.009-2.115.5-.3.99-.609,1.6-.988h-6.512v4.105Zm-33.669,43.758c-.341,1.367-.677,2.722-1.021,4.1h5.375v-4.1Zm48.161,0v4.116h5.372l-1.023-4.116Zm-49.724,6.243c-.345,1.39-.679,2.731-1.021,4.11h1.744v-4.11Zm54.905,4.1h1.754l-1.028-4.087h-.726Z",
    transform: "translate(-2193.887 197.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20502",
    "data-name": "Path 20502",
    d: "M3517.245,402.728c.319-.641.594-1.224.9-1.789a.694.694,0,0,1,.394-.25,1.621,1.621,0,0,1,.453-.01q18.4,0,36.808-.015a.955.955,0,0,1,1.068.677c.172.458.423.888.666,1.386Z",
    transform: "translate(-2246.673 -20.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20503",
    "data-name": "Path 20503",
    d: "M3565.364,378.751h-36.143c.336-.668.623-1.309.986-1.9.08-.131.424-.141.646-.142q4.942-.012,9.885-.006,11.478,0,22.956-.011c.472,0,.759.1.937.566C3564.821,377.75,3565.1,378.215,3565.364,378.751Z",
    transform: "translate(-2256.571 -1.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20504",
    "data-name": "Path 20504",
    d: "M3541.271,354.733c.323-.653.592-1.265.932-1.833.085-.142.4-.2.612-.2,2.969-.013,5.939-.009,8.909-.009q9.916,0,19.833-.013a.867.867,0,0,1,.975.613c.182.478.445.926.7,1.446Z",
    transform: "translate(-2266.531 18.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20505",
    "data-name": "Path 20505",
    d: "M3592.713,226.978h-21.556c.271-.14.395-.209.523-.269,3.275-1.53,6.547-3.064,9.83-4.578a1.048,1.048,0,0,1,.772-.048c3.383,1.553,6.754,3.132,10.128,4.707C3592.479,226.822,3592.541,226.87,3592.713,226.978Z",
    transform: "translate(-2291.233 126.771)",
    fill: "#0499bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20506",
    "data-name": "Path 20506",
    d: "M3519.574,429.028v-4.085h8.245v4.085Z",
    transform: "translate(-2248.598 -40.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20507",
    "data-name": "Path 20507",
    d: "M3579.672,424.911h8.244v4.084h-8.244Z",
    transform: "translate(-2298.271 -40.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20508",
    "data-name": "Path 20508",
    d: "M3647.952,425.017V429.1h-8.245v-4.082Z",
    transform: "translate(-2347.891 -41.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20509",
    "data-name": "Path 20509",
    d: "M3699.574,429.028v-4.085h8.245v4.085Z",
    transform: "translate(-2397.373 -40.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20510",
    "data-name": "Path 20510",
    d: "M3489.571,465.03v-4.084h8.245v4.084Z",
    transform: "translate(-2223.8 -70.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20511",
    "data-name": "Path 20511",
    d: "M3557.914,465.109h-8.222V461h8.222Z",
    transform: "translate(-2273.491 -70.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20512",
    "data-name": "Path 20512",
    d: "M3617.914,465.109h-8.222V461h8.222Z",
    transform: "translate(-2323.083 -70.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20513",
    "data-name": "Path 20513",
    d: "M3677.914,465.109h-8.222V461h8.222Z",
    transform: "translate(-2372.674 -70.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20514",
    "data-name": "Path 20514",
    d: "M3737.914,465.109h-8.222V461h8.222Z",
    transform: "translate(-2422.266 -70.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20515",
    "data-name": "Path 20515",
    d: "M3567.664,262.919h2v13.448h-2Z",
    transform: "translate(-2288.346 92.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20516",
    "data-name": "Path 20516",
    d: "M3591.665,262.918h2v13.448h-2Z",
    transform: "translate(-2308.183 92.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20517",
    "data-name": "Path 20517",
    d: "M3615.657,262.926h2v13.448h-2Z",
    transform: "translate(-2328.013 92.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20518",
    "data-name": "Path 20518",
    d: "M3639.665,262.917h2v13.448h-2Z",
    transform: "translate(-2347.856 92.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20519",
    "data-name": "Path 20519",
    d: "M3663.658,262.924h2v13.448h-2Z",
    transform: "translate(-2367.687 92.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20520",
    "data-name": "Path 20520",
    d: "M3687.653,262.93h2.006v13.448h-2.006Z",
    transform: "translate(-2387.52 92.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20521",
    "data-name": "Path 20521",
    d: "M3645.984,153.079h-6.329v-4.105h6.512c-.614.378-1.108.685-1.6.988-1.065.648-1.062,1.465.01,2.115l1.471.893Z",
    transform: "translate(-2347.849 187.152)",
    fill: "#0499bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20522",
    "data-name": "Path 20522",
    d: "M3477.189,424.886h4.354v4.1h-5.375C3476.511,427.608,3476.848,426.254,3477.189,424.886Z",
    transform: "translate(-2212.722 -40.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20523",
    "data-name": "Path 20523",
    d: "M3759.683,424.888h4.35c.34,1.368.677,2.722,1.023,4.116h-5.373Z",
    transform: "translate(-2447.054 -40.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20524",
    "data-name": "Path 20524",
    d: "M3468.178,460.876h.723v4.11h-1.744Z",
    transform: "translate(-2205.274 -70.643)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhmedabad);
export default __webpack_public_path__ + "static/media/ahmedabad.bbb65a6ce3cbeae829febfdbf5a35a5b.svg";
export { ForwardRef as ReactComponent };